<div class="sidenav-container">
  <!-- Header Section with Profile -->
  <div class="sidenav-header">
    <div class="header-content">
      <div class="logo-section">
        <!-- Use Angular assets path (files placed under src/assets/* are served at /assets/*) -->
     <img src="assets/broadcast_logof1.png"
       alt="Broadcast Services Logo"
       class="broadcast-logo"
       draggable="false"
       (error)="handleLogoError($event)"
     />
      </div>
      <div class="profile-section">
        <!-- <a routerLink="/profile" class="profile-icon" title="Profile"> -->
        <a class="profile-icon" title="Profile">
          <ng-container *ngIf="user?.picture; else defaultIcon">
            <img [src]="user.picture" 
                 alt="User Picture" 
                 class="profile-picture"
                 (load)="onImageLoad($event)"
                 (error)="onImageError($event)" />
          </ng-container>
          <ng-template #defaultIcon>
            <mat-icon>person</mat-icon>
          </ng-template>
        </a>
        <!-- Debug info (remove in production) -->
        <!-- <div *ngIf="user" style="position: absolute; top: 100px; left: 300px; background: white; padding: 10px; border: 1px solid #ccc; font-size: 12px; max-width: 300px; z-index: 9999;">
          <strong>Debug Info:</strong><br>
          Has picture: {{ !!user.picture }}<br>
          Picture URL: {{ user.picture || 'None' }}<br>
          Has GMIN: {{ !!user.extension_ef42828ce93541bd877d75958d40e00f_gmGMINanchor }}<br>
          GMIN: {{ user.extension_ef42828ce93541bd877d75958d40e00f_gmGMINanchor || 'None' }}
        </div> -->
      </div>
    </div>
  </div>

  <!-- Navigation Links -->
  <div class="sidenav-links" *ngIf="!user?.isAdmin && !user?.isOwner">
    <button 
      mat-button 
      class="menu-item" 
      *ngFor="let item of nonAdminMenuItems"
      [routerLink]="item.route"
      [class.active]="isActive(item.route)"
      routerLinkActive="active">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </button>
  </div>

  <div class="sidenav-links" *ngIf="user?.isAdmin && !user?.isOwner">
    <button 
      mat-button 
      class="menu-item" 
      *ngFor="let item of adminMenuItems"
      [routerLink]="item.route"
      [class.active]="isActive(item.route)"
      routerLinkActive="active">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </button>
  </div>

  <div class="sidenav-links" *ngIf="user?.isOwner">
    <button 
      mat-button 
      class="menu-item" 
      *ngFor="let item of ownerMenuItems"
      [routerLink]="item.route"
      [class.active]="isActive(item.route)"
      routerLinkActive="active">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </button>
  </div>

  <!-- For testing ONLY -->
  <!-- <div>Toggle Admin
    <button mat-button class="menu-item" (click)="toggleAdmin()">
      <span>{{ user?.isAdmin ? 'Disable Admin' : 'Enable Admin' }}</span>
    </button>
  </div> -->

  <!-- <div>Toggle Owner
    <button mat-button class="menu-item" (click)="toggleOwner()">
      <span>{{ user?.isOwner ? 'Disable Owner' : 'Enable Owner' }}</span>
    </button>
  </div> -->
</div>
